import React, { Component } from 'react';
import { connect } from 'react-redux';
import {CSSTransition,TransitionGroup} from 'react-transition-group';
import { resizeParent } from '../../services/Utils'
// Actions
import { configure, getConfiguration } from '../../actions/Settings'
import { getRequests, newPrayerRequest, incrementPrayer } from '../../actions/Prayer'

// Components
import Spinner from '../Spinner';
import Form from './Form';
import DefaultCard from './Cards/DefaultCard';

// Class
class TCCPrayerRequests extends Component {

    constructor(props){

        super(props);

        this.state = {
            page: 1,
            loaded: false,
            requests: null,
            total: props.total,
            buttonText: props.buttontext,
            showForm: false,
            nonce: props.nonce,
            email: props.email,
            category: props.category,
            autoRefresh: props.autorefresh
        }

        // Reload Automatically
        if(props.autorefresh === 'true'){
           // Reload Every 3 Minutes
            this.interval = setInterval(() => {
                this.setState({page:1});
                this.getRequests();
            }, 180000)
        }

        

    }

    getRequests(){

        let args = {
            page: this.state.page,
            total: this.state.total,
            category: this.state.category
        }

        this.props.getRequests(args)

    }

    componentDidMount(){

        this.props.configure(this.props.site);
        this.props.getConfiguration();

        // Get Requests
        this.getRequests();


    }

    componentDidUpdate(){
        resizeParent();
    }

    newPrayerRequest(args){

        const post = {...args};
        post.nonce = this.props.nonce;
        post.admin_email = this.props.email;
        post.total = this.props.total;
        post.page = 1;
        post.category = this.props.category;
        this.props.newPrayerRequest(post);
        this.setState({page:1,showForm:false});

    }

    handlePrayed(itemId){

        this.props.incrementPrayer(itemId,this.props.nonce);

    }

    loadMore(e){
        e.preventDefault();
        this.setState({page:this.state.page+1},this.getRequests);

    }

    renderRequests(){

        if(!this.props.prayer.requests) return false;

        return Object.keys(this.props.prayer.requests).map(key=> {
            let item = this.props.prayer.requests[key];
            return (
                <CSSTransition key={item.id} timeout={200} classNames="listtransition">
                    <DefaultCard {...item} key={item.id} prayed={(itemId) => this.handlePrayed(itemId)} />
                </CSSTransition>
            );
        })

    }


    render(){


        // Guard: Not loaded
        if(this.props.prayer.ui === 'loading') return (<div><Spinner /></div>);


        return (
            <div className="TCCPrayerRequests">

                <div className="prayer-request-controls">
                    <a className="button-outlined" onClick={() => this.setState({showForm : !this.state.showForm})}><span className="text">{this.props.buttontext}</span></a>
                </div>

                <TransitionGroup>
                    {(this.state.showForm && (

                        <CSSTransition key={1} timeout={200} classNames="form-transition">
                            <div className="prayer-request-form-wrap tcc-webcomponent-form-wrap">
                                <Form onSubmit={(values) => this.newPrayerRequest(values)} />
                            </div>
                        </CSSTransition>

                    ))}
                </TransitionGroup>

                {(this.props.prayer.uiNewRequest === 'success' && (
                    <div className="success"><span className="icon-check"></span></div>
                ))}

                <div className="prayer-results">

                    {this.renderRequests()}

                </div>

                <div className="prayer-request-controls">

                    <a href="javascript:;" onClick={(e) => this.loadMore(e)}>Load More</a>

                </div>

            </div>
        );
    }

}

const mapStateToProps = state => ({
    settings: state.Settings,
    prayer: state.Prayer
})

const mapDispatchToProps = dispatch => ({
    configure: (site) => dispatch(configure(site)),
    getConfiguration: () => dispatch(getConfiguration()),
    getRequests: (args) => dispatch(getRequests(args)),
    newPrayerRequest: (args) => dispatch(newPrayerRequest(args)),
    incrementPrayer: (itemId,nonce) => dispatch(incrementPrayer(itemId,nonce))
})

export default connect(mapStateToProps, mapDispatchToProps)(TCCPrayerRequests);
